"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectPayerMobile = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _components = require("../../../components");
var _useModalState = require("../../../utils/useModalState");
var _components2 = require("./components");
var _reactSelect = _interopRequireDefault(require("react-select"));
require("./SelectPayerMobile.less");
var _classnames = _interopRequireDefault(require("classnames"));
var _api = require("../api");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SelectPayerMobile = function SelectPayerMobile(_ref) {
  var options = _ref.options,
    groupedOptions = _ref.groupedOptions,
    form = _ref.form;
  var setFieldsValue = form.setFieldsValue,
    getFieldValue = form.getFieldValue;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOption = _useState2[0],
    setSelectedOption = _useState2[1];
  var selectRef = (0, _react.useRef)();
  var _useSelectPayerSeachS = (0, _api.useSelectPayerSeachState)(groupedOptions),
    searchOptions = _useSelectPayerSeachS.searchOptions,
    setSearchOptions = _useSelectPayerSeachS.setSearchOptions,
    searchValue = _useSelectPayerSeachS.searchValue,
    setSearchValue = _useSelectPayerSeachS.setSearchValue,
    handleOptionsSearch = _useSelectPayerSeachS.handleOptionsSearch;

  // Options virtualization criteria
  var virtualizeOptions = (0, _lodash.isEmpty)(searchValue) || searchValue.length < 3;
  var modal = (0, _useModalState.useModalState)();
  var payerId = getFieldValue('payer');
  var initialValueOption = (0, _react.useMemo)(function () {
    return (0, _lodash.find)(options, function (option) {
      return option.id === payerId;
    });
  }, [options, payerId]);
  var resetSearchValues = function resetSearchValues() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        closeModal: false
      },
      closeModal = _ref2.closeModal;
    if (closeModal) {
      modal.hide();
    }
    setSearchValue('');
    setSearchOptions(groupedOptions);
  };
  var handleOptionChange = function handleOptionChange(newValue, actionMeta) {
    if (actionMeta.action === 'select-option') {
      setSelectedOption(newValue);
      setFieldsValue({
        payer: newValue.id
      });
      resetSearchValues({
        closeModal: true
      });
    }
  };
  var handleInputClick = function handleInputClick(e) {
    e.preventDefault();
    e.target.blur();
    modal.show();
  };
  (0, _react.useEffect)(function () {
    if (initialValueOption && !selectedOption) {
      setSelectedOption(initialValueOption);
    }
  }, [initialValueOption]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_components.TextInput, {
    label: "Search insurance provider",
    name: "payer",
    icon: "search-24",
    iconPosition: "left",
    form: form,
    hideIconOnFocus: false,
    value: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.payerName,
    inputStyles: "gap-x-[5px]",
    onClick: handleInputClick,
    onChange: _lodash.noop
  }), /*#__PURE__*/_react.default.createElement(_components.Modal, {
    centered: true,
    visible: modal.visible,
    footer: null,
    wrapClassName: "group-filter-modal",
    bodyStyle: {
      padding: '0px'
    },
    maskClosable: true,
    destroyOnClose: true
  }, (0, _lodash.isEmpty)(options) ? /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: true,
    className: "flex w-full justify-center items-center"
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "min-h-[calc(100vh)] h-full"
  }, /*#__PURE__*/_react.default.createElement(_components2.CloseModal, {
    onClose: function onClose() {
      return resetSearchValues({
        closeModal: true
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
    placeholder: "Search by provider name",
    className: (0, _classnames.default)('select-payer-mobile', {
      'virtualized-options': virtualizeOptions
    }),
    classNamePrefix: "select-payer",
    options: searchOptions || groupedOptions,
    inputValue: searchValue,
    components: {
      Input: _components2.CustomInput,
      DropdownIndicator: _components2.SearchIcon,
      Option: function Option(props) {
        return /*#__PURE__*/_react.default.createElement(_components2.CustomOption, _extends({}, props, {
          searchValue: searchValue
        }));
      },
      MenuList: function MenuList(props) {
        return /*#__PURE__*/_react.default.createElement(_components2.CustomMenuList, _extends({}, props, {
          virtualizeOptions: virtualizeOptions
        }));
      },
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      }
    },
    onChange: handleOptionChange,
    onInputChange: handleOptionsSearch,
    noOptionsMessage: _components2.NoOptionsFoundMessage,
    ref: selectRef,
    captureMenuScroll: false,
    menuIsOpen: true,
    autoFocus: true
  }), /*#__PURE__*/_react.default.createElement(_components2.ClearSearch, {
    searchValue: searchValue,
    onClearSearch: function onClearSearch() {
      resetSearchValues();
      selectRef.current.focus();
    }
  }))));
};
exports.SelectPayerMobile = SelectPayerMobile;
var _default = SelectPayerMobile;
exports.default = _default;